
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage-solution",
      function () {
        return require("private-next-pages/self-storage-solution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-storage-solution"])
      });
    }
  